module.exports = __webpack_public_path__ + "img/linked_in.a882dcbe.svg";